<template>
  <div class="page">
    <div class="container">
      <div class="page__inner">
        <p class="page__counter">02</p>
        <h1 class="subtitle subtitle_red page__subtitle">Выстраивание эффективного диалога между государством, бизнесом и&nbsp;обществом</h1>
      </div>
    </div>

    <dialog-background />

    <page-footer
      :prev="{ name: 'companies' }"
      :next="{ name: 'ecosystem' }"
      :disabled="isDisabledRoute"
    />
  </div>
</template>

<script>
// eslint-disable-next-line
import { TimelineMax, TweenMax } from 'gsap'
import DialogBackground from '@/components/servicesSvg'
import PageFooter from '@/components/PageFooter'
import RouteMixin from '../mixins/route'

export default {
  name: 'dialogp',
  mixins: [RouteMixin],
  components: {
    DialogBackground,
    PageFooter
  },
  mounted () {
    new TimelineMax()
      .add(TweenMax.from('.dialog-bg', 0.5, { opacity: 0 }))
      .add(TweenMax.from('.page__counter', 0.3, { y: '-20px', opacity: 0 }))
      .add(TweenMax.from('.page__subtitle', 0.3, { y: '-10px', opacity: 0 }))
  },
  beforeRouteLeave (to, from, next) {
    this.isDisabledRoute = true

    new TimelineMax()
      .add(TweenMax.to('.page__subtitle', 0.3, { y: '10px', opacity: 0 }))
      .add(TweenMax.to('.page__counter', 0.3, { y: '20px', opacity: 0 }))
      .add(TweenMax.to('.dialog-bg', 0.5, { opacity: 0 }))
      .eventCallback('onComplete', () => {
        next()
      })
  }
}
</script>
